<template>
  <div v-if="!this.networkStore.online" class="container mt-3">
    <div class="alert alert-danger d-inline-flex align-items-center" role="alert">
      <em class="align-middle material-icons">error_outlined</em>
      <div>
        <span>
          Aktuell besteht keine Verbindung zum Server. Das kann daran liegen, dass du nicht mit dem Internet verbunden bist, oder dass der Server aktuell ein Problem hat.
          Wenn das Problem weiterhin besteht, wende dich bitte an den Administrator.<br>
          <b>Änderungen, die du jetzt machst, werden nicht gespeichert!</b>
        </span>
      </div>
    </div>
  </div>
  <router-view></router-view>
  <footer class="footer">
    <div class="container d-flex flex-wrap justify-content-between align-items-center py-3 my-4 border-top">
      <p class="mb-0 text-muted">© 2026 Simon Lachnit</p>
      <p class="mb-0 text-muted">v{{version}}</p>
    </div>
  </footer>
</template>

<script>
import {useAuthenticationStore} from "@/stores/authentication";
import {useNetworkStore} from "@/stores/network";
import {version} from './version';

export default {
  name: 'App',
  data() {
    return {
      version: version
    }
  },
  setup() {
    const authenticationStore = useAuthenticationStore();
    const networkStore = useNetworkStore();
    return {authenticationStore, networkStore};
  },
  mounted() {
    this.authenticationStore.getCSRFToken();
  },
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  min-height: 100%;
  position: relative;
  padding-bottom: 6rem;
}

body, html {
  height: 100%;
}

footer {
  height: 6rem;
  width: 100%;
  position: absolute;
  left: 0;
  bottom: 0;
}
</style>
